var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-picker-container"},[_c('div',{staticClass:"filter"},[_c('vue-datepicker-local',{attrs:{"value":_vm.selected,"disabledDate":_vm.disabledDate,"local":_vm.local,"type":_vm.type,"popup-class":_vm.type === 'inline' ? 'force-inline' : '',"format":_vm.formatDate},on:{"input":_vm.emitDateSelected}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7884def8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/DateRangePicker.vue
// module id = null
// module chunks = 